import axios from 'axios';

const getAutomatonUrl = async () => {
  const {
    data: { automatonUrl },
  } = await axios.get<{ automatonUrl: string }>('/secrets/automatonUrl');

  return automatonUrl;
};

export default getAutomatonUrl;
